import { cloneDeep, forEach, isEmpty } from 'lodash';

import { EventTypeInfo } from '../global.constants';

export function overrideEventTypesFromConfigs(
  eventTypes: { [key: string]: EventTypeInfo },
  overrides: { [key: string]: EventTypeInfo } | null,
  defaults: { [key: string]: EventTypeInfo }
): void {
  forEach(eventTypes, (_v, key) => delete eventTypes[key]);

  if (!isEmpty(overrides)) {
    forEach(overrides, (item) => {
      if (item?.value) {
        eventTypes[item.value] = item;
      }
    });
  } else if (!isEmpty(defaults)) {
    forEach(defaults, (item) => {
      if (item?.value) {
        eventTypes[item.value] = cloneDeep(item);
      }
    });
  }
}
